/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as RadarLayerSpec } from '../../../../layer/preset/radar/radar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type RadarLayerType = StandardChartLayerSpec & RadarLayerSpec & ILayerTypeSpec;

// 创建雷达图数据类型验证器
const validateRadarDataTypes = createDataTypeValidator('radar', [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number', array: true }
]);

// 创建雷达图编码验证器
const validateRadarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y', array: true }
]);

// 额外的检查函数
const additionalRadarChecks = (layer: RadarLayerType) => {
  // 检查y字段是否是数组且长度符合要求（>2且<=10）
  if (Array.isArray(layer.encoding.y)) {
    const yCount = layer.encoding.y.length;
    if (yCount <= 2 || yCount > 10) {
      utils.logger.warn(
        'warning',
        `The "y" field count of the "${layer.type}" layer must be greater than 2 and less than or equal to 10`
      );
    }
  } else {
    utils.logger.warn('warning', `The "y" field of the "${layer.type}" layer must be an array`);
    layer.__isEncodingValid = false;
  }
};

// 创建并导出雷达图处理器
export const radar = createLayerProcessor<RadarLayerType>(
  'radar',
  validateRadarEncoding,
  validateRadarDataTypes,
  additionalRadarChecks
);
